import NewAnalyze from './NewAnalyze';
import AnalysisHistory from './AnalysisHistory';
import { useEffect } from 'react';
import { Text, useWindowSize } from '../../../../modules/Dashboard';
import { usePredictContext } from '../../context/PredictContextProvider';
import { useSearchParams } from 'react-router-dom';
import AssistantIcon from '../AssistantIcon';
import { MOBILE_SIZE } from '../../../../core/constants/common';


const TickersMain = () => {
    const { width } = useWindowSize()
    const { assistant, step } = usePredictContext()
    const [, setSearchParams] = useSearchParams()

    useEffect(() => {
        if (!assistant.assistant) {
            step.setCurrentStep("assistant")
            setSearchParams({ step: "assistant" })
        }
    }, [assistant.assistant])

    return (
        <div className='grid grid-cols-3 gap-5 auto-rows-auto mx-auto'>
            <div className='col-span-3 flex flex-col gap-2'>
                <div className='flex items-center gap-2'>
                    {
                        width >= MOBILE_SIZE ?
                            <AssistantIcon assistantValue={assistant?.assistant?.value} /> :
                            <></>
                    }
                    <Text tid={assistant?.assistant?.label} className="text-xl !text-[#F3E8FF]" />
                </div>
                <Text tid={"start-analyze-hint"} className="!text-[#DAB2FF] hidden md:inline" />
            </div>
            <div className='col-span-3 lg:col-span-2 !h-max'>
                <NewAnalyze />
            </div>
            <div className='col-span-3 lg:col-span-1 !h-full'>
                <AnalysisHistory />
            </div>
        </div>
    )
}

export default TickersMain